import React from 'react';
import { AlertTriangleIcon, BabyIcon, CalendarClockIcon } from 'lucide-react';
import { MaternityFile } from '../../types';
import { formatReviewDate, getDuePostnatalReviews } from './postnatalSchedule';
type PostnatalDueNotificationsProps = {
  files: MaternityFile[];
  onSelect?: (file: MaternityFile) => void;
};
export function PostnatalDueNotifications({
  files,
  onSelect
}: PostnatalDueNotificationsProps) {
  const due = getDuePostnatalReviews(files);
  if (due.length === 0) return null;
  return <section className="rounded-lg border border-amber-200 bg-amber-50 p-4" aria-labelledby="postnatal-due-heading" data-id="element-4120" data-mp="3gg4s7l2rfb78">
      <div className="flex items-center gap-2" data-id="element-4121" data-mp="3ccyddp1l0bp5">
        <CalendarClockIcon className="h-5 w-5 text-amber-700" data-id="element-4122" data-mp="37g7wx0lv7e37" />
        <h2 id="postnatal-due-heading" className="text-sm font-bold text-amber-900" data-id="element-4123" data-mp="37hsvd1bavh6c">
          Postnatal reviews due ({due.length})
        </h2>
      </div>
      <ul className="mt-3 space-y-2" data-id="element-4124" data-mp="1vz884eyq7hdx">
        {due.map(({
        file,
        status
      }) => {
        const name = `${file.patient?.firstName || ''} ${file.patient?.surname || ''}`.trim() || file.bmcFileNumber;
        const body = <>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-pink-600" data-id="element-4125" data-mp="qdwfo2brg2vd">
                <BabyIcon className="h-4 w-4" data-id="element-4126" data-mp="vchhg66nuulx" />
              </span>
              <span className="min-w-0 flex-1" data-id="element-4127" data-mp="gowcs7u50nbw">
                <span className="block text-sm font-semibold text-gray-900" data-id="element-4128" data-mp="gn1r2rb1kr6r">
                  {name} · {file.bmcFileNumber}
                </span>
                <span className="block text-sm text-gray-700" data-id="element-4129" data-mp="7p9brn5bljjd">
                  Mother and baby due for the {status.label.toLowerCase()}{' '}
                  postnatal review — {formatReviewDate(status.scheduledDate)}
                </span>
              </span>
              {status.isOverdue && <span className="inline-flex items-center gap-1 rounded-full bg-red-100 px-2.5 py-1 text-xs font-semibold text-red-800" data-id="element-4130" data-mp="2pmyjdphs3ak">
                  <AlertTriangleIcon className="h-3.5 w-3.5" data-id="element-4131" data-mp="24fu74fceq3vp" /> Overdue
                </span>}
            </>;
        return <li key={`${file.id}-${status.kind}`} data-id="element-4132" data-mp="1vlpg9vx9wsg6">
              {onSelect ? <button type="button" onClick={() => onSelect(file)} className="flex w-full items-center gap-3 rounded-md border border-amber-200 bg-white p-3 text-left hover:bg-amber-50 focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-4133" data-mp="1qne95syd4w1n">
                  {body}
                </button> : <div className="flex items-center gap-3 rounded-md border border-amber-200 bg-white p-3" data-id="element-4134" data-mp="2eejpsac4nsd0">
                  {body}
                </div>}
            </li>;
      })}
      </ul>
    </section>;
}